import { EventEmitter, Injectable } from '@angular/core';

/**
 * Picture in picture dialog service
 */
@Injectable({
    providedIn: 'root',
})
export class PipDialogService {
    /**
     * Remote Video Stream
     */
    setRemoteStream = new EventEmitter<MediaStream>();

    /**
     * Local Video Stream
     */
    setLocalStream = new EventEmitter<MediaStream>();

    /**
     * User has hung up
     */
    hungUp = new EventEmitter();

    /**
     * PIP requests hang up (handled by CallWebrtcService)
     */
    requestHangUp = new EventEmitter<void>();

    /**
     * Toggle Microphone
     */
    toggleMic = new EventEmitter();

    /**
     * Toggle camera
     */
    toggleCamera = new EventEmitter();

    /**
     * Remote video toggled
     */
    remoteVideoToggled = new EventEmitter<boolean>();

    /**
     * Remote audio toggled (true = muted / disabled)
     */
    remoteAudioToggled = new EventEmitter<boolean>();

    /**
     * Local video enabled state synced into PIP
     */
    localVideoToggled = new EventEmitter<boolean>();

    /**
     * Local mic enabled state synced into PIP
     */
    localMicrophoneToggled = new EventEmitter<boolean>();

    /**
     * Participant display names for PIP tiles
     */
    participantNamesChange = new EventEmitter<{ remote: string; local: string }>();

    /**
     * Call partner status change
     */
    hasCallPartnerChange = new EventEmitter<boolean>();

    /**
     * Is Screen Capture change
     */
    isScreenCaptureChange = new EventEmitter<boolean>();

    /**
     * Start screen capture
     */
    startScreenCapture = new EventEmitter();

    /**
     * End screen capture
     */
    stopScreenCapture = new EventEmitter();

    /**
     * Volume change
     */
    volumeChange = new EventEmitter<number>();
}
